import React, { useState, useRef } from "react"; // Added useRef
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = ({ user }) => { // 1. Added 'user' as a prop
  const navigate = useNavigate();
  const dropdownRef = useRef(null); // 2. Defined 'dropdownRef'
  const [step, setStep] = useState(1); 
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");

  const handleSendOtp = () => {
    if (!name || !mobile) {
      alert("Please enter name and mobile");
      return;
    }
    if (mobile.length !== 10) {
      alert("Enter valid mobile number");
      return;
    }
    alert("📲 OTP sent: 1234");
    setStep(2);
  };

  const handleVerifyOtp = () => {
    if (otp === "1234") {
      const loginDate = new Date().getTime();
      localStorage.setItem("token", "dummy_token");
      localStorage.setItem("user", JSON.stringify({ name, mobile }));
      localStorage.setItem("loginTimestamp", loginDate.toString());
      alert("✅ Login successful");
      // Use window.location.href to force a refresh so App.js picks up the new user state
      window.location.href = "/agro"; 
    } else {
      alert("❌ Invalid OTP");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-side-image">
        <div className="overlay-text">
          <h1>Freshness Delivered</h1>
          <p>Join our community of farmers and smart shoppers.</p>
        </div>
      </div>
      
      <div className="login-form-container">
        <div className="login-box-premium">
          <div className="brand-header">
            <span className="agro-icon">🌱</span>
            <h2>ATR AGRO MART</h2>
            <p>{step === 1 ? "Create your account" : "Verify your identity"}</p>
          </div>

          <div className="form-content">
            {step === 1 ? (
              <>
                <div className="input-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    placeholder="e.g. Rahul Kumar"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                {/* Fixed Section: 'user' is now defined via props */}
                {!user ? (
                  <button 
                    className="login-btn-premium" 
                    onClick={() => navigate('/login')} 
                    style={{ display: 'none' }} // Hidden because we are already on the Login page
                  >
                    Login
                  </button>
                ) : (
                  <div className="user-menu-wrapper" ref={dropdownRef}>
                    {/* ... user pill code ... */}
                  </div>
                )}

                <div className="input-group">
                  <label>Mobile Number</label>
                  <div className="mobile-input-wrapper">
                    <span className="prefix">+91</span>
                    <input
                      type="number"
                      placeholder="98765 43210"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                  </div>
                </div>

                <button className="login-btn-main" onClick={handleSendOtp}>
                  Send OTP <span>→</span>
                </button>
              </>
            ) : (
              <>
                <div className="otp-info">
                  <p>We sent a code to <strong>+91 {mobile}</strong></p>
                  <button className="edit-btn" onClick={() => setStep(1)}>Edit Number</button>
                </div>

                <div className="input-group">
                  <label>Enter 4-Digit OTP</label>
                  <input
                    type="number"
                    className="otp-input"
                    placeholder="0 0 0 0"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>

                <button className="login-btn-main" onClick={handleVerifyOtp}>
                  Verify & Login
                </button>
              </>
            )}
          </div>
          
          <p className="terms-text">
            By continuing, you agree to ATR's <span>Terms of Service</span> and <span>Privacy Policy</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;